<!--新建工单-->
<template>
  <div class="orderBody">
    <div class="con">
      <div class="leftPart">
        <p>分组</p>
        <el-select v-model="nowOrderGroupnew" placeholder="请选择" @change="pickerOrderGroup_fn">
          <el-option v-for="item in orderGroupList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
        </el-select>
        <p class="title-top">开始时间</p>

        <el-date-picker v-model="orderStartTime" type="datetime" placeholder="选择日期时间" align="right"
          :picker-options="pickerOptions"> </el-date-picker>
        <p class="title-top">截止时间</p>

        <el-date-picker v-model="orderEndTime" type="datetime" placeholder="选择日期时间" align="right"
          :picker-options="pickerOptions"> </el-date-picker>
        <p class="title-top">抄送人</p>
        <div class="user-select">
          <div class="user-text" @click="isUserTree = !isUserTree">
            <span v-if="userName =='请选择抄送人'">请选择抄送人</span>
            <span v-else style="color:#1a1a1a">{{userName}}</span>
            <img :class="[{'tran-img':isUserTree}]" src="@/assets/arrowb.png" alt="">
          </div>
          <div class="user-tree" :style="{'height':heights+'px'}" v-show="isUserTree" @mouseleave="isUserTree = false">
            <div class="user-tree-con">
              <el-scrollbar style="height:calc(100% - 10px);width: 100%;">
                <el-tree class="filter-tree" show-checkbox :data="userTree" highlight-current ref="tree"
                  @check="currentChecked" auto-expand-parent :props="defaultProps">
                  <template #default="{ node,data }">
                    <span class="custom-tree-node">
                      <img src="../../../../public/static/image/elTree/1.9.png"
                        v-if="data.entityName=='UsePowerUnit'" />
                      <img src="@/assets/unifyImg/user.png" v-else />
                      <span style="margin-left:5px">{{ node.label }}</span>
                    </span>
                  </template>
                </el-tree>
              </el-scrollbar>
            </div>
          </div>
        </div>
        <p v-show="isCycle" class="title-top">周期类型</p>
        <div v-show="isCycle">
          <div class="flexBetween cycleTime">
            <p :class="{isCheck:cycleTime == 'day'}" @click="cycleTime = 'day'">日</p>
            <p :class="{isCheck:cycleTime == 'week'}" @click="cycleTime = 'week'">周</p>
            <p :class="{isCheck:cycleTime == 'month'}" @click="cycleTime = 'month'">月</p>
            <p :class="{isCheck:cycleTime == 'year'}" @click="cycleTime = 'year'">年</p>
          </div>
        </div>
        <p v-show="isCycle" class="title-top" style="color:#1a1a1a">预期发布时间</p>
        <p v-show="isCycle" v-for="(item,index) in cycleTimeList"
          style="padding: 3px 0 !important;margin: 0;color:#1a1a1a" :key="index">{{item}}</p>
      </div>
      <div class="rightPart">
        <div class="rightPart-top">
          <div class="Files-top">
            <div class="ic-left">
              <span>创建工单</span>
            </div>
            <div class="btns">
              <el-button type="primary" @click="isCycle?upload('CycleOrder',cycleTime):upload('Order')"
                class="last-el-button">发布工单</el-button>
            </div>
          </div>
          <div class="right-top">

            <div class="flex-left">
              <div class="top-mome"><span>工单名称（必填）：</span><el-input v-model="orderTitle"
                  placeholder="请输入工单名称"></el-input></div>
              <div class="top-mome" style="margin-left:40px"><span>工单描述（选填）：</span><el-input v-model="orderContent"
                  placeholder="请输入工单描述" type="textarea" :rows="1"></el-input></div>
            </div>

          </div>
        </div>
        <createNode ref="createNodeBean" :isImport="isImport" :nowOrderGroup="nowOrderGroup" :nowFlow="nowFlow"
          :orderStartTime='orderStartTime' :orderEndTime="orderEndTime" @pickerWorkFlow="pickerWorkFlow"></createNode>
        <!-- <div class="flexBetween" style="flex-direction: column;float: right;">
					<p class="buttonP" @click="pickerWorkFlow" style="margin: 10px;width: 160px;">从工作流导入</p>
					<p @click="isCycle?upload('CycleOrder',cycleTime):upload('Order')" class="buttonP" style="margin: 10px;width: 160px;">发布</p>
				</div> -->
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
  import treeBody from '@/components/module/slotModule/treeBody.vue'
  import datePicker from '@/components/module/datePicker/base/datePicker.vue'
  import createNode from '@/page/order/createOrder/newCreateNode.vue'
  import treeSingleSelection from '@/components/module/selection/base/treeSingleSelection.vue'
  export default {
    components: {
      treeBody,
      datePicker,
      createNode,
      treeSingleSelection,
    },
    props: [],
    data () {
      return {
        userName: "请选择抄送人",
        heights: document.getElementById('app').clientHeight-500,//屏幕高度 - 导航栏高度
        isUserTree: false,
        radio: "2",
        defaultProps: {
          children: 'next',
          label: 'name'
        },
        pickerOptions: {

          shortcuts: [{
            text: '今天',
            onClick (picker) {
              picker.$emit('pick',new Date());
            }
          },{
            text: '昨天',
            onClick (picker) {
              const date=new Date();
              date.setTime(date.getTime()-3600*1000*24);
              picker.$emit('pick',date);
            }
          },{
            text: '一周前',
            onClick (picker) {
              const date=new Date();
              date.setTime(date.getTime()-3600*1000*24*7);
              picker.$emit('pick',date);
            }
          }]
        },
        isImport: true,
        nowOrderGroup: undefined,
        nowOrderGroupnew: "",
        showSaveToDemo: false,
        nowInputFlow: undefined,
        nowInputDemo: undefined,
        participants: [],
        orderTitle: "",
        orderContent: "",
        orderStartTime: new Date(new Date().getTime()),
        orderEndTime: new Date(new Date().getTime()+24*60*60*1000+30*60*1000),
        nowFlow: {
          name: '默认工作流',
          next: []
        },
        isCycle: true,
        cycleTime: 'day',
        groupId: "",
        // orderGroupList:[]
      }
    },
    created () {
      debugPage=this
    },
    mounted () {
      // this.$store.orderGroupStore.commit('getOrderGroupTree')
      //    this.orderGroupList = this.$store.orderGroupStore.state.orderGroupTree
      if(this.orderGroupList!=undefined) {
        this.nowOrderGroup=this.orderGroupList[0]
        this.nowOrderGroupnew=this.orderGroupList[0].id
      }
      //从缓存中判断是否是从事件界面跳转过来的
      this.isFromEvent()
    },
    computed: {
      orderGroupList () {
        // this.$store.orderGroupStore.commit('getOrderGroupTree')
        // var data = this.$store.orderGroupStore.state.orderGroupTree
        var data=this.$store.orderGroupStore.getters.getOrderGroupTree
        return data
      },
      priorityList () {
        return this.$store.orderStore.state.priorityList
      },
      cycleTypeList () {
        return this.$store.orderStore.state.cycleTypeList
      },
      userTree () {
        console.log("树形",this.$store.userStore.getters.getUnitUserTree);
        return this.$store.userStore.getters.getUnitUserTree
      },
      deleteIco () {
        return this.$store.resourcesStore.getters.getResourcesByName('/wedoButton/delete.png')
      },
      getFlowList () {
        return this.$store.workFlowStore.getters.getFlowList
      },
      getDemoList () {
        //模板列表
        return this.$store.orderStore.getters.getOrderTemplateList('NotStarted')
      },
      nowFlowTree () {
        if(this.nowInputFlow==undefined) {
          return undefined
        }
        return this.$store.workFlowStore.getters.getFlowTreeByFlowId(this.nowInputFlow.flowId)
      },
      nowParticipantsNames () {
        if(isempty(this.participants)) {
          return '点击选择抄送人'
        }
        return this.participants.map(item => item.username).join(' , ')
      },
      nowOrderGroupName () {
        if(this.nowOrderGroup==undefined) {
          return '选择分组'
        }
        return this.nowOrderGroup.name
      },
      flowTree () {
        return [{
          name: '私有工作流',
          id: '1',
          next: this.getFlowList(1)
        },{
          name: '公有工作流',
          id: '0',
          next: this.getFlowList(0)
        }]
      },
      cycleTimeList () {
        //计算出的下两次运行时间
        var start=new Date(this.orderStartTime.getTime())
        var list=[]
        list.push(start.formatByTime('-'))
        for(var i=0;i<3;i++) {
          switch(this.cycleTime) {
            case 'day':
              start=new Date(start.getFullYear(),start.getMonth(),start.getDate()+1,start.getHours(),start.getMinutes(),
                start.getSeconds())
              break
            case 'week':
              start=new Date(start.getFullYear(),start.getMonth(),start.getDate()+7,start.getHours(),start.getMinutes(),
                start.getSeconds())
              break
            case 'month':
              var lastDate=start.getDate()
              var nDate=new Date(start.getFullYear(),start.getMonth()+1,start.getDate(),start.getHours(),start.getMinutes(),
                start.getSeconds())
              if(lastDate!=nDate.getDate()) {
                start=new Date(start.getFullYear(),start.getMonth()+2,start.getDate(),start.getHours(),start.getMinutes(),
                  start.getSeconds())
                list.push(start.formatByTime('-'))
                continue
              }
              start=nDate
              break
            case 'year':
              start=new Date(start.getFullYear()+1,start.getMonth(),start.getDate(),start.getHours(),start.getMinutes(),
                start.getSeconds())
              break
          }
          list.push(start.formatByTime('-'))
        }
        list.push("...")
        return list
      }
    },
    watch: {
      nowFlowTree (nv,ov) {
        //加载在watch只是为了让它更快计算
      },
      userTree (nv,ov) {

      },
      orderGroupList (nv,ov) {
        this.nowOrderGroup=nv[0]
        this.nowOrderGroupnew=nv[0].id
      },
      flowTree (nv,ov) {},
      radio (val) {
        if(val=="1") {
          this.isCycle=false
        } else {
          this.isCycle=true
        }
      }
    },
    methods: {
      addUsers () {
        this.$dialogMethod.openMultipleSelectionDialog('抄送人',this.userTree,this.participants.map(item => item.userId),
          respon => {
            //一次可以添加多个
            this.participants=respon
            // console.log("抄送人 。",respon);
          })
      },
      upload (orderType,cycleType) {
        if(isempty(this.orderTitle)) {
          this.$dialogMethod.showMessage("工单标题不能为空!")
          return
        }
        var nodes=this.$refs.createNodeBean.getData()
        // archivesIdsFun
        var archivesIdsId=this.$refs.createNodeBean.archivesIdsFun()
        // console.log("发布archivesIdsId",archivesIdsId);

        let archivesIds=[]

        if(nodes.length==0) {
          this.$dialogMethod.showMessage("至少需要具有一个节点!")
          return
        }
        //var actionList = this.$refs.createNodeBean.actionList
        for(var i=0,len=nodes.length;i<len;i++) {


          if(nodes[i].nodeType==2) {
            if(nodes[i].next.length!=0) {
              archivesIds=nodes[i].next.map(item => {
                return item.linkObject
              }).join(",")
            } else {

              archivesIds=nodes[i].archivesIds

            }
            nodes[i].archivesIds=copy(archivesIds)

          }
          if(isempty(nodes[i].nodeUsers)) {
            this.$dialogMethod.showMessage(`${nodes[i].nodeName} 节点必须有负责人!`)
            return
          }
          // console.log("nodes[i].next",nodes[i].next);
          // console.log("nodes[i].archivesIds",nodes[i].archivesIds);
          // console.log("nodes[i].nodeType == 2",nodes[i].nodeType == 2);
          if(isempty(nodes[i].next)&&isempty(nodes[i].archivesIds)&&nodes[i].nodeType==2) {
            // console.log("不符合条件",nodes[i]);
            this.$dialogMethod.showMessage(`${nodes[i].nodeName} 的节点类型为“巡检”时必须选择台账设备!`)
            return
          }
          /* if(isempty(actionList) && nodes[i].nodeType == 0) {
            this.$dialogMethod.showMessage("操作项至少需要有一个操作步骤!")
            return
          } */
          for(var i1=0,len1=nodes[i].next.length;i1<len1;i1++) {
            var item=nodes[i].next[i1]
            if(isempty(item.next)&&nodes[i].nodeType==0) {
              this.$dialogMethod.showMessage(`${nodes[i].nodeName} 操作项至少需要有一个操作步骤!`)
              return
            }
          }
        }
        // console.log("最终nodes",nodes);
        // return
        var workTime=this.orderEndTime.getTime()-this.orderStartTime.getTime()
        // var workTime = this.orderEndTime.getTime()
        if(workTime<=0) {
          this.$dialogMethod.showMessage("截至时间不能早于开始时间!")
          return
        } else if(this.orderEndTime.getTime()<new Date().getTime()+30*60*1000) {
          this.$dialogMethod.showMessage("截至时间必须在30分钟后!")
          return
        }
        this.$dialogMethod.showLoading('正在发布');
        this.$api.orderApi.addOrder(this.nowOrderGroup.groupId,orderType,this.orderTitle,
          this.orderContent,this.orderStartTime.getTime(),workTime,
          undefined,cycleType,
          nodes,
          //participants
          this.participants.filter(item => {
            return item!=undefined
          }).map(item => item.userId).join(',')
          ,respon => {
            this.$dialogMethod.showMessage('发布成功!')
            this.$dialogMethod.closeLoading()
          })
      },
      pickerOrderGroup () {
        // console.log("this.orderGroupList",this.orderGroupList);
        // console.log("this.nowOrderGroup",this.nowOrderGroup);
        this.$dialogMethod.openSingleItemDialog('选择工单分组',this.orderGroupList,this.nowOrderGroup==undefined?
          undefined:[this.nowOrderGroup.id],
          respon => {
            this.nowOrderGroup=respon[0]
          })
      },
      pickerOrderGroup_fn (val) {
        var arr=this.orderGroupList.filter(item => item.id==val)
        this.nowOrderGroup=arr[0]
        // this.nowOrderGroup = respon[0]
      },
      pickerWorkFlow () {
        this.$dialogMethod.openSingleItemDialog('选择工作流',this.flowTree,this.nowInputFlow==undefined?
          undefined:this.nowInputFlow.id,
          respon => {
            this.nowInputFlow=respon[0]

            if(this.nowInputFlow==undefined) {
              this.$dialogMethod.showMessage('未选中工作流!')
              return
            }
            //获取工作流并且加载和提示
            this.$dialogMethod.openAgreeDialog('导入工作流','将会覆盖当前工作流，是否继续?',respon => {
              if(this.nowFlowTree==undefined) {
                this.$dialogMethod.showMessage('当前选中工作流信息还在获取中，请稍后重试！')
              } else {
                //加载
                this.nowOrderGroupnew=this.nowInputFlow.groupId+''
                this.$set(this.nowFlow,'next',copy(this.nowFlowTree.next))
              }
            })
          })
      },
      isFromEvent () {
        if(this.$store.cacheStore.state.eventToOrderCache!=undefined) {
          var eventBean=this.$store.cacheStore.state.eventToOrderCache
          this.$store.cacheStore.state.eventToOrderCache=undefined
          //类型指定为抢修
          if(this.orderGroupList!=undefined) {
            this.nowOrderGroup=this.orderGroupList.find(item => item.id==3)
          }
          //描述里面写事件内容
          this.orderContent='告警对象:【{0}】,事件等级:【{1}】,内容:【{2}】,产生时间:【{3}】'.format(eventBean.linkobject,eventBean.levelName,eventBean.description,new Date(eventBean.time).formatByTime())
        }
      },
      //抄送人
      currentChecked (val,SelectedObj) {
        // console.log("巴黎",SelectedObj);
        var data=[]
        SelectedObj.checkedNodes.forEach(item => {
          if(item.entityName=='PcmUser') {
            data.push(item)
          }
        })
        this.participants=data
        if(data.length==0) {
          this.userName='请选择抄送人'
        } else {
          this.userName=this.participants.map(item => item.username).join(' , ')
        }
        // console.log("data",data);
      },
    }
  }
</script>

<style scoped lang="scss">
  .orderBody {
    display: flex;

  }

  .con {
    width: 100%;
    height: 100%;
    display: flex;
  }

  .user-select {
    width: 240px;
    position: relative;

    .user-text {
      width: 100%;
      height: 36px;
      border: 1px solid #cccccc;
      border-radius: 2px;
      box-sizing: border-box;
      position: relative;
      // text-align: center;
      line-height: 36px;

      span {
        color: #999999;
        margin-left: 10px;
      }

      img {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 7px;
        transition: 0.3s;

        &.tran-img {
          transform: translateY(-50%) rotateZ(180deg);
        }
      }

    }

    .user-tree {
      position: absolute;
      width: 100%;
      background-color: #fff;
      padding-top: 8px;
      z-index: 99;

      .user-tree-con {
        width: 100%;
        height: 100%;
        border: 1px solid #cccccc;
        box-sizing: border-box;
      }
    }
  }

  .leftPart {
    width: 280px;

    background-color: #fff;
    padding: 12px 20px 20px 20px;
    margin-right: 8px;
    box-sizing: border-box;

    /* border: silver 1px solid; */
    /deep/.el-input__inner {
      width: 240px;
    }



  }

  .title-top {
    margin-top: 20px !important;
  }

  .leftPart>p,
  .rightPart>p {
    width: 178px;
    margin: 0.03rem 0;
    color: #1A1A1A;
    font-size: 14px;
  }

  .pickerText {

    color: #1a1a1a !important;
    border: 1px solid #DCDFE6 !important;
  }

  .buttonP {
    cursor: pointer;
    background: #DA7800;
    color: white;
    padding: .1rem;
    border: 1px solid #DCDFE6;
    text-align: center;
    border-radius: 10px;
    margin-top: 10px;
  }

  .buttonP:hover,
  .saveToDemo:hover,
  .saveToDemo>p:hover {
    background: #Ca7800;
  }

  .uploadDiv {
    width: 160px;
    margin-top: .1rem;
  }

  .rightPart {
    width: calc(100% - 300px);


    // border-radius: 5px;
    .rightPart-top {
      background-color: #fff;
      padding: 12px 20px 10px 20px;
      box-sizing: border-box;
      margin-bottom: 8px;
    }

    .right-top {
      display: flex;
      align-items: center;
      width: 100%;
      margin-top: 20px;
      margin-bottom: 10px;

      .flex-left {
        display: flex;
        align-items: center;
        width: 100%;

        .top-mome {
          display: flex;
          align-items: center;

          /deep/.el-input {
            width: 2.4rem;
            height: 36px;
          }

          /deep/.el-input__inner {
            height: 36px;
          }

          /deep/.el-textarea {
            width: 2.4rem;
          }

          /deep/.el-textarea__inner {
            height: 36px !important;
          }
        }
      }

    }
  }

  .uploadDiv>p {
    margin: 0;
    width: 120px;
    border-radius: 10px 0 0 10px;
  }

  .saveToDemo {
    width: 40px;
    height: 100%;
    background: #DA7800;
    border-radius: 0 10px 10px 0;
    border: white .01rem solid;
    border-left: 0;
    cursor: pointer;
    position: relative;
  }

  .saveToDemo>p {
    position: absolute;
    background: #DA7800;
    width: 100px;
    left: -85px;
    padding: .1rem;
    border-radius: 10px;
    border: white .01rem solid;
    color: white;
  }



  .participants {
    width: 130px !important;
  }

  .tabP {
    width: 50%;
    text-align: center;
    border-bottom: #000000 dashed 1px;
    padding: 5px 0 10px 0;
    cursor: pointer;
  }

  .tabP:first-child,
  .inputButtonP:first-child {
    border-right: #000000 dashed 1px;
  }

  .tabP:first-child {
    border-radius: 20px 0 0 0;
  }

  .tabP:last-child {
    border-radius: 0 20px 0 0;
  }

  .tabP.isCheck {
    background: #DA7800;
    color: white;
  }

  .inputButtonP {
    width: 50%;
    text-align: center;
    border-top: #000000 dashed 1px;
    padding: 10px 0 5px 0;
    cursor: pointer;
  }

  .inputButtonP:hover {
    color: #DA7800;
  }

  .leftPart>p.pickerText {
    margin-top: 0;
  }

  .pickerBody {
    width: 160px;
  }

  /deep/.el-radio {
    margin-right: 20px;
    margin-top: 3px;
  }

  .cycleTime {
    border: 1px solid #DCDFE6;
    width: 160px;
    border-radius: 5px;
    overflow: hidden;
  }

  .cycleType>p {
    text-align: center;
    width: calc((100% - 1px)/2);
    padding: 5px;
    cursor: pointer;

  }

  .cycleType>p:first-child {
    border-right: silver dashed 1px;
  }

  .cycleType>p:hover,
  .cycleType>p.isCheck,
  .cycleTime>p:hover,
  .cycleTime>p.isCheck {
    background: #409EFF;
    color: white;
  }

  .cycleTime>p {
    width: calc((100% - 3px)/4);
    text-align: center;
    // border-right: silver 1px dashed;
    border-right: 1px solid #DCDFE6;
    cursor: pointer;
    color: #999;
    padding: 5px 0;

  }

  .cycleTime>p:last-child {
    border: 0;
  }
</style>